import { Typography, Button } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { cn } from "@/lib/utils";
import type { RadioSelectionEditorProps } from "../types";
import { VariableType } from "@/pages/subscriptions/constants";

const getEditorTitle = (variableType: VariableType): string => {
  switch (variableType) {
    case VariableType.AGGREGATION:
      return "Aggregate entity metrics by:";
    case VariableType.COMPARISON:
      return "Alert when metric:";
    case VariableType.CHANGE_TYPE:
      return "Change type:";
    case VariableType.DATE_RANGE:
      return "Compare to:";
    default:
      return "Select option:";
  }
};

const RadioSelectionEditor = ({
  value,
  variableType,
  filteredOptions,
  onValueChange,
  onValidationError,
}: RadioSelectionEditorProps) => {
  const title = getEditorTitle(variableType);

  return (
    <div className="al-space-y-3">
      <Typography variant="body" weight="medium" className="al-text-sm">
        {title}
      </Typography>
      <div className="al-space-y-2">
        {filteredOptions.map((option) => (
          <Button
            type="button"
            variant="ghost"
            key={option.value}
            className={cn(
              "al-w-full al-h-auto !al-justify-start al-border al-rounded-lg al-p-3 al-cursor-pointer al-transition-all",
              value === option.value
                ? "al-border-blue-500 al-bg-blue-50"
                : "al-border-gray-200 hover:al-border-gray-300"
            )}
            onClick={() => {
              onValueChange(option.value, option.label);
              onValidationError("");
            }}
          >
            <Stack direction="row" gap="sm" className="al-items-start">
              <div className="al-mt-1">
                <Stack
                  direction="row"
                  className={cn(
                    "al-w-4 al-h-4 al-rounded-full al-border-2 al-items-center al-justify-center",
                    value === option.value ? "al-border-blue-500" : "al-border-gray-300"
                  )}
                >
                  {value === option.value && (
                    <div className="al-w-2 al-h-2 al-rounded-full al-bg-blue-500" />
                  )}
                </Stack>
              </div>
              <div className="al-flex-1">
                <Typography variant="body" className="al-text-sm al-font-medium">
                  {option.label}
                </Typography>
              </div>
            </Stack>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default RadioSelectionEditor;
